module.exports = __webpack_public_path__ + "img/28.fa040272.jpg";